import apiClient from "@/api/client";
import type { SubTaskComment } from "@/features/tasks/types";

const wrap = <T>(res: { data: { data: T } }) => res.data.data;

export const subtaskCommentsApi = {
  list: (taskId: string, subtaskId: string) =>
    apiClient
      .get<{ data: SubTaskComment[] }>(`/tasks/${taskId}/subtasks/${subtaskId}/comments/`)
      .then(wrap),

  create: (taskId: string, subtaskId: string, content: string, mentionIds?: string[], replyTo?: string | null) =>
    apiClient
      .post<{ data: SubTaskComment }>(`/tasks/${taskId}/subtasks/${subtaskId}/comments/`, {
        content,
        mention_ids: mentionIds ?? [],
        ...(replyTo ? { reply_to: replyTo } : {}),
      })
      .then(wrap),

  update: (taskId: string, subtaskId: string, id: string, content: string, mentionIds?: string[]) =>
    apiClient
      .patch<{ data: SubTaskComment }>(
        `/tasks/${taskId}/subtasks/${subtaskId}/comments/${id}/`,
        { content, ...(mentionIds ? { mention_ids: mentionIds } : {}) }
      )
      .then(wrap),

  delete: (taskId: string, subtaskId: string, id: string) =>
    apiClient.delete(`/tasks/${taskId}/subtasks/${subtaskId}/comments/${id}/`),

  uploadCommentImage: (taskId: string, subtaskId: string, file: File): Promise<string> => {
    const form = new FormData();
    form.append("file", file);
    return apiClient
      .post<{ data: { url: string } }>(
        `/tasks/${taskId}/subtasks/${subtaskId}/comments/upload-image/`, form,
        { headers: { "Content-Type": "multipart/form-data" } }
      )
      .then((res) => res.data.data.url);
  },
};
